export const isMobileHeaderName = "x-is-mobile";

// "gb-ve" short for "gb-viewed-experiments", for obFusCaTiOn
export const gbViewedExperimentsParamName = "gb-ve";

export const gbViewedExperimentsHeaderName = "gb-viewed-experiments";
export const gbActiveFeaturesHeaderName = "gb-active-features";
export const gbPayloadHeaderName = "gb-payload";

export const gbViewedExperimentDataLayerEventName =
  "growthbookExperimentViewed";
